import React, { Component, useState,useEffect  } from 'react';
import cookie from 'react-cookies';
import Voting from "./Voting";
import Advert from "./Advert";
import classNames  from "classnames";


class Vindex extends Component {
	constructor(props){
		super(props);
		this.state = {
			alldata: null,
			showq: false,
		}
		this.dfpList = [];
		this.dfpCount = 0;
		 this.getVotes = this.getVotes.bind(this);
		this.dfpUpdate = this.dfpUpdate.bind(this);
		this.dfpReady = this.dfpReady.bind(this);
		// this.vote = this.vote.bind(this);
		// this.openvote = this.openvote.bind(this);

	}

	triggerEvent (SheVoteAction, SheVoteValue) {
		dataLayer.push({event: "She Vote", virtualPageURL: location.href, SheVoteAction, SheVoteValue})
	}

	chunkArray(array){
		let perChunk = 3;

		let result = array.reduce((resultArray, item, index) => {
			const chunkIndex = Math.floor(index/perChunk)

			if(!resultArray[chunkIndex]) {
				resultArray[chunkIndex] = [] // start a new chunk
			}

			resultArray[chunkIndex].push(item)

			return resultArray
		}, [])
		return result;
	}
	dfpUpdate(){
		this.dfpCount++;
	}

	dfpReady(adunit){
		this.dfpList.push(adunit)

		if(this.dfpCount == this.dfpList.length){
			googletag.pubads().refresh(this.dfpList);
			this.dfpCount = 0;
			this.dfpList = [];
		}
	}

	getVotes(){
		let that = this;
		var myHeaders = new Headers();
		myHeaders.append('pragma', 'no-cache');
		myHeaders.append('cache-control', 'no-cache');
		fetch('/wp-json/she-rest-api/getAllVotes/',{
			method:"POST",
			headers: myHeaders
		}).then(function(res){
			return res.json();
		})
		.then(function(response){
			let finArray = that.chunkArray(response);
			that.setState({alldata: finArray});
			return response;
		}).catch(function(error){
			console.error(error);
		});
	}




	componentDidMount(){
		this.getVotes(this.props.vid);
	}


	render(){
		const {alldata, showq} = this.state;
		return <div>
			{
				alldata?
					alldata.map((item, index) => {
						 let setNum = 2;
						return (
							<div className="w-index" key={index}>
								<div className="left-index">
									{item? item.map((itemi, index) => <Voting key={index} vid={itemi} wstyle={"style"+index} index={true}/>) : ''}
								</div>
								<div className="right-index">
									<div className="grid-ads text-center">
										<div className={classNames("ad_300x250", (index % 2) === 0 ? 'desktop-visible' : 'mobile-visible')}>
											<Advert dfpReady={this.dfpReady} dfpUpdate={this.dfpUpdate} position={setNum === 1 ? 'firstMediumRectangle' : 'loopMediumRectangle'} />
										</div>
									</div>
								</div>
							</div>

						)
					}):''
			}
		</div>
	}

}

export default Vindex



// WEBPACK FOOTER //
// ./src/Vindex.js